// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class SavedItemsController {
   $location: any
   $scope: any
   $timeout: any
   events: any
   flow: any
   flowConfigs: any
   i18n: any
   idle: any
   idleMessage: any
   keepalive_interval: any
   savedItems: any
   strategies: any
   strategy: any
   constructor($scope: any, savedItems: any, $timeout: any, events: any, flow: any, embeddedValues: any, i18n: any, $location: any, l10n: any) {
      this.flowAuthChange = this.flowAuthChange.bind(this)
      this.clear = this.clear.bind(this)
      this.toggle = this.toggle.bind(this)
      this.keepalive = this.keepalive.bind(this)
      this.flowSave = this.flowSave.bind(this)
      this.defineStrategies = this.defineStrategies.bind(this)
      this.selectStrategy = this.selectStrategy.bind(this)
      this.$scope = $scope
      this.savedItems = savedItems
      this.$timeout = $timeout
      this.events = events
      this.flow = flow
      this.i18n = i18n
      this.$location = $location
      this.idle = false
      this.idleMessage = false
      this.keepalive_interval = 60*1000 // 60 seconds
      this.flowConfigs = this.flow.configs
      this.$scope.auth = this.flow.auth

      this.$scope.saveditems =
      {visible:  false}

      this.$scope.embeddedValues = embeddedValues

      this.$scope.flashTip = this.i18n.translations.TEMP_FOLDER_NOTICE
      this.$scope.regTip = this.i18n.translations.SAVED_ITEMS
      this.$scope.tooltipMsg = this.$scope.flashTip

      this.strategies = this.defineStrategies()
      this.selectStrategy('summon')

      this.$scope.$watch('idle', (idle: any) => {
         this.idle = idle
         if (idle) {
            return this.clear()
         }
      })

      this.$scope.$watch('idleMessage', (idleMessage: any) => {
         this.idleMessage = idleMessage
         if (idleMessage) {
            return this.savedItems.showIdleMessage()
         }
      })

      this.flow.on('authChange', this.flowAuthChange)

      this.$timeout(this.keepalive, this.keepalive_interval)

      this.$scope.$on('$destroy', () => {
         return this.flow.off('authChange', this.flowAuthChange)
      })
   }

   flowAuthChange() {
      return this.strategy = this.flow.auth.user.authenticated ?
         this.selectStrategy('flow')
         :
         this.selectStrategy('summon')
   }


   clear() {
      this.savedItems.clear()
      if (!this.idle) { return this.events.publish("actions", "saved_items:clear") }
   }

   toggle() {
      // If not on /search, change the route to /search and wait for the route change to complete
      // before toggling the saved items dialog.
      if (this.$location.path() !== "/search") { 
         // Register a listener for routeChangeSuccess event
         const unregisterRouteChangeSuccess = this.$scope.$on('$routeChangeSuccess', () => {
            // If the route changes to /search, toggle the saved items dialog
            this._doToggle()
            // Unregister the listener after it has been called
            unregisterRouteChangeSuccess()
         })
         // Change the route to /search
         this.$location.path("/search") 
      } else { // If already on /search, toggle the saved items dialog directly
         this._doToggle()
      }
   }

   // Private method to handle the actual toggling logic
   _doToggle() {
      // Toggling based on saveditems.visible was losing
      // the active view state after clicking the saved
      // items dialog's close button then attempting to reopen
      // the dialog via the saved items folder.
      // Therefore, toggle based on the current view.
      if (this.$scope.viewState.currentView === "savedItems") {
         this.$scope.setWindowTitle(this.i18n.translations.RESULTS_FOR + `\"${this.$scope.search.query}\"`)
         this.$scope.saveditems.visible = false
         this.$scope.viewState.currentView = "search"
         return this.events.publish("actions", "saved_items:close")
      } else {
         this.$scope.setWindowTitle(this.i18n.translations.SAVED_ITEMS)
         this.$scope.setRetainState(true)
         this.$scope.saveditems.visible = true
         this.$scope.viewState.currentView = "savedItems"
         return this.events.publish("actions", "saved_items:open")
      }
   }

   keepalive() {
      if (!this.idle) {
         this.savedItems.save()
         return this.$timeout(this.keepalive, this.keepalive_interval)
      }
   }

   flowSave(document: any) {
      return this.flow.save([document])
   }

   defineStrategies() {
      const strategies = {
         summon: {
            add:       this.savedItems.add,
            remove:    this.savedItems.remove,
            clear:     this.savedItems.clear,
            contains:  this.savedItems.contains,
            items:     this.savedItems.items,
            toggle:    this.toggle,
            authd:     false,
            user:      this.savedItems.user,
            loginEnabled: this.savedItems.loginEnabled
         },

         flow: {
            add:       this.flowSave,
            remove:    angular.noop,
            clear:     angular.noop,
            contains:  this.flow.contains,
            items:     this.flow.items,
            toggle:    angular.noop,
            authd:     true
         }
      }

      return strategies
   }

   selectStrategy(strategyName: any) {
      return (() => {
         const result = []
         for (var name in this.strategies[strategyName]) {
            var fn = this.strategies[strategyName][name]
            this.$scope.saveditems.strategy = strategyName
            result.push(this.$scope.saveditems[name] = fn)
         }
         return result
      })()
   }
}

SavedItemsController.$inject = ['$scope', 'savedItemsService', '$timeout', 'eventService', 'flowService', 'embeddedWidgetValues', 'translationService', '$location', 'localizationService']

angular.module('summonApp.controllers')
   .controller('SavedItemsCtrl', SavedItemsController)
